<div class="border-bottom d-flex justify-content-between py-1"
  [ngClass]="{'highlighted': isHighlighted}">
  <div class="d-flex align-items-center">
    <div class="item-image {{size}} rounded d-flex align-items-center justify-content-center mr-3">
      @if (item.images?.length) {
        <img
          [src]="$safeNavigationMigration(item.images[0]?.getImageByFormat('xsmall')?.url)"
          [alt]="item.description">
      }
      @if (!item.images?.length) {
        <mat-icon>no_photography</mat-icon>
      }
    </div>
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column">
        <span>{{item.description}}</span>
        <span class="mat-caption"> {{item.inventory}}</span>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-end">
    @if (uiRoleManagerService.canI(eRoleActions.EDIT_ITEM) && showDeleteButton) {
      <button mat-icon-button
        color="primary"
        class="mr-3"
        (click)="removeLink.emit(item)">
        <mat-icon>delete</mat-icon>
      </button>
    }

    @if (!isHighlighted) {
      <button mat-icon-button
        color="primary"
        [matTooltip]="'COMMON.LABEL.DETAILS' | translate"
        (click)="onLoadItem(item)">
        <mat-icon>visibility</mat-icon>
      </button>
    }
  </div>
</div>